import { BrowserRouter, Navigate, Route, Routes } from "@modica-library/react19";
import { Verify } from "./pages/Verify";
import { DashboardLayout } from "./pages/DashboardLayout";
import { DashboardHome } from "./pages/DashboardHome";
import { SendMessagePage } from "./pages/SendMessagePage";
import { InboxPage } from "./pages/InboxPage";

export function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Navigate to="/verify" replace />} />
        <Route path="/verify" element={<Verify />} />
        <Route path="/dashboard" element={<DashboardLayout />}>
          <Route index element={<DashboardHome />} />
          <Route path="send" element={<SendMessagePage />} />
          <Route path="inbox" element={<InboxPage />} />
        </Route>
        <Route path="*" element={<Navigate to="/verify" replace />} />
      </Routes>
    </BrowserRouter>
  );
}
